import { render, staticRenderFns } from "./Izvestaj.vue?vue&type=template&id=e2e7c7a2&scoped=true&"
import script from "./Izvestaj.vue?vue&type=script&lang=js&"
export * from "./Izvestaj.vue?vue&type=script&lang=js&"
import style1 from "./Izvestaj.vue?vue&type=style&index=1&id=e2e7c7a2&prod&scoped=true&lang=css&"
import style2 from "./Izvestaj.vue?vue&type=style&index=2&id=e2e7c7a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e7c7a2",
  null
  
)

export default component.exports